import { CHARTER_COLORS as theme } from "../shared/controleTheme";
import { buttonBase, controleModalOverlayStyle, dossierActionButtonStyle } from "../shared/styles/layoutStyles";

export const inputStyle = {
    border: `1px solid ${theme.borderStrong}`,
    borderRadius: "7px",
    padding: "7px 9px",
    fontSize: "13px",
    background: theme.surface,
    color: theme.ink,
    boxSizing: "border-box",
};

export const saveDossierButtonStyle = {
    ...dossierActionButtonStyle,
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
};

export const validateDossierButtonStyle = {
    ...dossierActionButtonStyle,
    background: theme.accent,
    borderColor: theme.accent,
    color: "white",
};

export const sectionTitleStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "8px",
    padding: "14px 20px",
    borderRadius: "8px",
    background: "#e2f5ee",
    border: "1px solid #c9ece0",
    borderLeft: `4px solid ${theme.accent}`,
    color: theme.ink,
    fontSize: "17px",
    fontWeight: 950,
    boxShadow: "0 1px 2px rgba(12, 59, 60, 0.06)",
};

export const sectionTitleMarkerStyle = {
    width: "0",
    height: "0",
    borderRadius: "999px",
    background: "transparent",
    flexShrink: 0,
};

export const pageHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
    flexWrap: "wrap",
    padding: "14px 16px",
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
};

export const createDossierButtonStyle = {
    ...buttonBase,
    minHeight: "38px",
    padding: "9px 14px",
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
    fontWeight: 900,
    boxShadow: "0 8px 18px rgba(37, 99, 235, 0.18)",
};

export const dossierListShellStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
};

export const eyebrowStyle = {
    color: theme.primaryDark,
    fontSize: "12px",
    fontWeight: 950,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
};

export const dossierToolbarStyle = {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "14px",
    overflow: "visible",
};

export const dossierTableCardStyle = {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.04)",
};

export const metricToneStyle = tone => ({
    primary: { background: theme.primarySoft, border: "#b9d4cc", color: theme.primaryDark },
    success: { background: theme.successSoft, border: "#a9e8cf", color: "#0d704a" },
    warning: { background: theme.warningSoft, border: "#ead99b", color: "#80620e" },
    danger: { background: theme.dangerSoft, border: "#f4b8af", color: "#9a2f20" },
    neutral: { background: theme.surfaceMuted, border: theme.border, color: theme.ink },
}[tone] || { background: theme.surfaceMuted, border: theme.border, color: theme.ink });

export const metricTileStyle = {
    display: "grid",
    alignContent: "center",
    gap: "4px",
    minHeight: "76px",
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
};

export const metricValueStyle = {
    fontSize: "23px",
    lineHeight: 1,
    fontWeight: 950,
};

export const metricLabelStyle = {
    color: theme.muted,
    fontSize: "12px",
    fontWeight: 850,
};

export const statusPillStyle = finished => ({
    display: "inline-flex",
    alignItems: "center",
    minHeight: "24px",
    padding: "0 9px",
    borderRadius: "999px",
    background: finished ? theme.successSoft : theme.warningSoft,
    border: finished ? "1px solid #86efac" : "1px solid #fed7aa",
    color: finished ? "#166534" : "#9a3412",
    fontSize: "11px",
    fontWeight: 950,
    whiteSpace: "nowrap",
});

export const activeDossierShellStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    width: "100%",
};

export const activeDossierHeaderStyle = {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "22px 24px",
    boxShadow: "0 8px 22px rgba(12, 59, 60, 0.06)",
};

export const activeDossierTopRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
};

export const activeDossierMetaGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "8px",
    marginTop: "14px",
};

export const controleTabsStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    width: "100%",
    gap: "12px",
    padding: 0,
    border: 0,
    borderRadius: 0,
    background: "transparent",
    boxShadow: "none",
};

export const printReportButtonStyle = {
    ...buttonBase,
    minHeight: "38px",
    padding: "8px 14px",
    background: "white",
    borderColor: "#dfe6e2",
    color: theme.ink,
    fontWeight: 900,
    boxShadow: "none",
};

export const controleTabButtonStyle = active => ({
    border: active ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "14px 16px",
    cursor: "pointer",
    background: active ? "#e8f1ef" : theme.surface,
    color: theme.ink,
    fontWeight: 900,
    boxShadow: active ? "0 1px 0 rgba(12, 59, 60, 0.08)" : "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    minHeight: "74px",
});

export const controleStepNumberStyle = active => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    background: active ? theme.primary : theme.surfaceMuted,
    border: active ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
    color: active ? "white" : theme.muted,
    fontSize: "12px",
    fontWeight: 950,
    flexShrink: 0,
});

export const controleStepDetailStyle = active => ({
    color: active ? theme.primaryDark : theme.muted,
    fontSize: "11px",
    fontWeight: 800,
});

export const controleNestedModalOverlayStyle = {
    ...controleModalOverlayStyle,
    zIndex: 1260,
};
